"use client";

import { Select } from "@/components/Select";
import { BaseSelectProps } from "@/components/Select/Select";
import { getDataLinkAttributes } from "@/helpers";
import { CallbackReturnType } from "@/types";
import { Dropdown as DropdownType } from "@/types/General/Dropdown";
import { FC, PropsWithChildren, useEffect, useMemo, useRef } from "react";

type DropdownBlockProps = {
  dlt?: string;
  dld?: string;
  placeholder: string;
  onChange?: (
    value: DropdownType,
    elem: HTMLDivElement | null,
  ) => CallbackReturnType;
  onInitialize?: (elem: HTMLDivElement | null) => CallbackReturnType;
} & Omit<BaseSelectProps, "selectedDecoration">;

export const DropdownBlock: FC<PropsWithChildren<DropdownBlockProps>> = ({
  options,
  dld,
  dlt,
  placeholder,
  onInitialize,
  ...props
}) => {
  const ref = useRef<HTMLDivElement | null>(null);
  const placeholderValue = useMemo(
    () => ({ label: placeholder, value: "", disabled: true }),
    [placeholder],
  );
  useEffect(() => {
    if (onInitialize) {
      onInitialize(ref.current);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const onChange = async (value: DropdownType) => {
    if (props.onChange) {
      await props.onChange(value, ref.current);
    }
  };

  return (
    <Select
      {...props}
      {...getDataLinkAttributes({ dld, dlt })}
      variant="large rectangular"
      ref={ref}
      value={props.value ?? placeholderValue}
      options={
        placeholder ? [placeholderValue, ...(options ?? [])] : (options ?? [])
      }
      onChange={onChange}
    />
  );
};
